import { useNavigate } from 'react-router-dom';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// project imports
import useAuth from 'hooks/useAuth';

// assets
import { IconLogout } from 'utils/icons';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //
// Demo items removed (Edit/View/Social Profile, Billing don't exist in
// do-ra.cz yet) - only a real, working action stays here for now.

export default function ProfileTab() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      {/* px: 2.5 (2026-08-29, real bug fixed - "Odhlásit se" bylo o pár px
          vlevo od ikony "Nastavení uživatele" pod ním) - ListItemButton má
          defaultní px:2 (16px), zatímco AccordionSummary v
          UserSettingsAccordion/AttendanceAccordion používá explicitně
          px:2.5 (20px) - bez sjednocení se ikony pod sebou nekryly. */}
      <ListItemButton onClick={handleLogout} sx={{ px: 2.5 }}>
        <ListItemIcon>
          <IconLogout style={{ fontSize: '1.4rem' }} />
        </ListItemIcon>
        <ListItemText primary="Odhlásit se" />
      </ListItemButton>
    </List>
  );
}
